import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { UserCircle, Mail, Shield } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();

  return (
    <div data-testid="profile-page" className="space-y-6 animate-fade-in max-w-xl">
      <h1 className="text-2xl font-bold tracking-tighter font-['Outfit']">Profilo</h1>
      <div className="card-surface p-6 space-y-5">
        <div className="flex items-center gap-4">
          {user?.picture ? (
            <img src={user.picture} alt="" className="w-16 h-16 rounded-full" />
          ) : (
            <div className="w-16 h-16 rounded-full bg-[#002FA7] flex items-center justify-center text-white text-2xl font-bold">
              {user?.name?.[0]?.toUpperCase() || "U"}
            </div>
          )}
          <div>
            <h2 className="text-lg font-semibold font-['Outfit']">{user?.name}</h2>
            <span className="inline-flex items-center gap-1 text-xs text-zinc-500 bg-zinc-100 rounded-full px-2 py-0.5 mt-1">
              <Shield className="w-3 h-3" /> {user?.role_name || (user?.role === "OWNER" ? "Proprietario" : "Operatore")}
            </span>
          </div>
        </div>
        <div className="space-y-3 pt-2">
          <div className="flex items-center gap-3 text-sm">
            <Mail className="w-4 h-4 text-zinc-400" />
            <span className="text-zinc-600">{user?.email}</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <UserCircle className="w-4 h-4 text-zinc-400" />
            <span className="text-zinc-600">ID: {user?.id?.slice(0, 8)}...</span>
          </div>
        </div>
      </div>
    </div>
  );
}
